import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import SearcheableUserSelect from 'components/Users/SearcheableUserSelect'
import { selectors as UserGroupSelectors } from 'data/userGroups'
import {
  providesUpdateUserGroup,
  providesDeleteUserGroup,
} from 'components/Organizations/dataSync/userGroups'
import Confirm from 'components/Utils/Modal/Confirm'
import { ThinChevronIcon } from 'components/Utils/Icons'
import { Button, Text } from 'components/base'
import { Input } from 'components/Utils/Form'

function FormLabel({ children, htmlFor }) {
  return (
    <div className="margin-vertical-normal">
      <label htmlFor={htmlFor} className="shade-05 font-weight-bold pointer">
        {children}
      </label>
    </div>
  )
}

class UpdateGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteModalIsOpen: false,
      selectedUserIds: props.userGroupMembers.map(user => user.id),
      groupName: props.userGroup.name,
    }
  }
  render() {
    return (
      <React.Fragment>
        <div
          onClick={() => this.props.goToList()}
          className="pointer flexbox flexbox-align-center"
        >
          <ThinChevronIcon
            size={12}
            className="margin-right-small shade-30"
            style={{ transform: 'rotate(180deg)' }}
          />
          <span className="shade-20">Back to your groups</span>
        </div>
        <form onSubmit={this.onUpdateUserGroup}>
          <Text.Subtitle className="margin-vertical-large">
            Manage group
          </Text.Subtitle>

          <FormLabel htmlFor="user-group-name">Edit group name</FormLabel>
          <Input
            id="user-group-name"
            className="margin-bottom-normal"
            value={this.state.groupName}
            onChange={event => this.setState({ groupName: event.target.value })}
            style={{ width: 270 }}
            placeholder="E.g, leadership, sales, developers"
            required
            autoFocus
          />
          <FormLabel htmlFor="user-group-name">Manage group members</FormLabel>
          <SearcheableUserSelect
            selectedValues={this.state.selectedUserIds}
            onChange={selectedUserIds => this.setState({ selectedUserIds })}
            inputProps={{
              id: 'user-group-members',
              placeholder: 'Search for a member',
            }}
          />
          <div className="flexbox margin-top-large">
            <Button.Primary
              className="margin-right-medium"
              onClick={this.onUpdateUserGroup}
              disabled={!this.state.groupName}
            >
              Update group
            </Button.Primary>
            <Button.Danger
              onClick={event => {
                event.preventDefault()
                event.stopPropagation()
                this.setState({ deleteModalIsOpen: true })
              }}
            >
              Delete group
            </Button.Danger>
          </div>
        </form>
        <Confirm
          show={this.state.deleteModalIsOpen}
          onConfirm={this.onDeleteConfirm}
          onCancel={this.closeModal}
        >
          <div className="text-align-left">
            <Text.Subtitle className="margin-top-normal">
              This action cannot be undone
            </Text.Subtitle>

            <div className="shade-20 margin-top-medium font-size-large">
              <div>
                Are you sure you want to delete the{' '}
                <span className="font-weight-bold">
                  {this.props.userGroup.name}
                </span>{' '}
                group?
              </div>
              <div>Users in the group might lose access to some channels</div>
            </div>
          </div>
        </Confirm>
      </React.Fragment>
    )
  }

  closeModal = event => {
    this.setState({
      deleteModalIsOpen: false,
    })
  }

  onDeleteConfirm = event => {
    this.closeModal(event)
    this.props
      .deleteUserGroup({ userGroupId: this.props.userGroup.id })
      .then(() => {
        this.props.goToList()
      })
  }

  onUpdateUserGroup = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!this.state.groupName) {
      return
    }
    this.props
      .updateUserGroup({
        userGroupId: this.props.userGroup.id,
        input: {
          userIds: this.state.selectedUserIds,
          name: this.state.groupName,
        },
      })
      .then(() => this.props.goToList())
  }
}

export default compose(
  providesUpdateUserGroup(),
  providesDeleteUserGroup(),
  connect((state, { userGroupId }) => ({
    userGroup: UserGroupSelectors.getUserGroup(state, userGroupId),
    userGroupMembers: UserGroupSelectors.getUserGroupMembers(
      state,
      userGroupId
    ).toArray(),
  }))
)(UpdateGroup)
